"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _commonOptionCard = require("@mmc/common-option-card");
var _starRating = _interopRequireDefault(require("./star-rating"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _dealerCard = _interopRequireDefault(require("./dealer-card.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DealerCard = function DealerCard(_ref) {
  var _clsx;
  var dealer = _ref.dealer,
    type = _ref.type,
    theme = _ref.theme,
    value = _ref.value,
    onChange = _ref.onChange,
    isSelected = _ref.isSelected,
    showRating = _ref.showRating,
    distance = _ref.distance,
    isMapEnabled = _ref.isMapEnabled;
  return /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
    type: type,
    label: dealer.name,
    theme: theme,
    fullTap: true,
    isSelected: isSelected,
    onChange: onChange,
    value: value,
    classes: isMapEnabled ? [_dealerCard["default"].dealerCard] : []
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_dealerCard["default"].dealerCardInner, (_clsx = {}, _clsx[_dealerCard["default"].ratingPadding] = !showRating, _clsx))
  }, showRating && dealer.rating !== null && /*#__PURE__*/_react["default"].createElement(_starRating["default"], {
    rating: dealer.rating
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _dealerCard["default"].description
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme.bodyCopy, _dealerCard["default"].address)
  }, dealer.address), dealer.distance && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme.bodyCopy, _dealerCard["default"].distance)
  }, dealer.distance, " ", distance.shortName))));
};
var _default = DealerCard;
exports["default"] = _default;